import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class ConfirmModal extends Component {
  static displayName = 'ConfirmModal';

  static propTypes = {
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    buttonName: PropTypes.string,
    description: PropTypes.string,
    greenButton: PropTypes.string,
    title: PropTypes.string
  };

  static defaultProps = {
    greenButton: 'confirm'
  };

  render() {
    var title = null;
    if (this.props.title) {
      title = <div className="modal-title">{this.props.title}</div>;
    }
    var cancelClassName = classnames({
      confirm: this.props.greenButton === 'cancel',
      'modal-button': this.props.greenButton !== 'cancel'
    });

    var confirmClassName = classnames({
      confirm: this.props.greenButton === 'confirm',
      'modal-button': this.props.greenButton !== 'confirm'
    });

    return (
      <div>
        {title}
        <div className="modal-description">{this.props.description}</div>
        <div className="button-container">
          <span
            className={cancelClassName}
            style={{ marginRight: 10 }}
            onClick={this.props.onClose}
          >
            Cancel
          </span>
          <div className={confirmClassName} onClick={this.props.onConfirm}>
            {this.props.buttonName}
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmModal;
